import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import PageTitle from "../../components/pagetitle/PageTitle";
import { useTranslation } from "react-i18next";
import CourseSectionS3 from "../../components/CourseSectionS3/CourseSectionS3";
import InstructorAuth from "../../Wrappers/HoC/InstructorAuth";
import { useGetAllInstructorCoursesMutation } from "../../api/instructorApi";
import { Languages } from "../Extensions/Languages";
import BankInfoModal from "../CustomComponents/BankInfoModal";
import {
  useCreateCourseAsyncMutation,
  useGetCourseByIdMutation,
  useRemoveCourseAsyncMutation,
  useUpdateCourseMutation,
} from "../../api/courseApi";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useChechBankInformationMutation } from "../../api/accountApi";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Input } from "reactstrap";
import { instructorApi } from "../../api/instructorApi";
import { useDispatch,useSelector } from "react-redux";
import { toast } from "react-toastify";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useLazyGetAllCategoriesForSelectedQuery } from "../../api/categoryApi";
import Spinner from "react-bootstrap/Spinner";
import { useAddBankInfoMutation, useInstructorSubDetailMutation, useInstructorUpdateMutation } from "../../api/InstructorSubApi";
import { useBulkVideoAsyncMutation } from "../../api/videoApi";

// Add shimmer animation styles
const shimmerStyles = `
  @keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }

  body:has(.instructor-editorial-page) {
    background:
      linear-gradient(90deg, rgba(47, 79, 64, 0.05) 1px, transparent 1px),
      linear-gradient(0deg, rgba(47, 79, 64, 0.045) 1px, transparent 1px),
      linear-gradient(135deg, #f7f0e4 0%, #efe2cf 100%);
    background-size: 34px 34px, 34px 34px, auto;
  }

  .instructor-editorial-page {
    background:
      linear-gradient(90deg, rgba(47, 79, 64, 0.05) 1px, transparent 1px),
      linear-gradient(0deg, rgba(47, 79, 64, 0.045) 1px, transparent 1px),
      linear-gradient(135deg, #f7f0e4 0%, #efe2cf 100%);
    background-size: 34px 34px, 34px 34px, auto;
    min-height: auto;
  }

  .instructor-editorial-page nav[aria-label="Breadcrumb"] {
    max-width: 1200px;
    margin: 1.5rem auto 0;
    background: rgba(255, 251, 243, 0.94) !important;
    border: 1px solid rgba(110, 90, 66, 0.2) !important;
    border-radius: 8px !important;
    box-shadow: 0 18px 46px rgba(58, 45, 34, 0.1) !important;
  }

  .instructor-editorial-page nav[aria-label="Breadcrumb"] a,
  .instructor-editorial-page nav[aria-label="Breadcrumb"] span {
    color: #2f4f40 !important;
  }

  .instructor-editorial-page nav[aria-label="Breadcrumb"] li:last-child span {
    color: #8d4e2f !important;
    font-weight: 700 !important;
  }

  .instructor-action-card {
    background: rgba(255, 251, 243, 0.94) !important;
    border: 1px solid rgba(110, 90, 66, 0.2) !important;
    border-radius: 8px !important;
    box-shadow: 0 18px 46px rgba(58, 45, 34, 0.1) !important;
    max-width: 1120px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0 !important;
  }

  body:has(.instructor-editorial-page) .course-section {
    padding-top: 1.5rem !important;
  }

  body:has(.instructor-editorial-page) .course-section > div:first-child {
    margin-bottom: 0 !important;
  }

  body:has(.instructor-editorial-page) .wpo-popular-area.section-padding {
    padding-top: 1.5rem !important;
  }

  body:has(.instructor-editorial-page) .course-section .container {
    padding-top: 0 !important;
  }

  body:has(.instructor-editorial-page) .pagination-wrapper {
    width: 100%;
  }

  body:has(.instructor-editorial-page) .pg-pagination {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 0.55rem !important;
    list-style: none !important;
    padding: 0 !important;
    margin: 0 !important;
    flex-wrap: wrap !important;
  }

  body:has(.instructor-editorial-page) .pg-pagination li button {
    min-width: 42px !important;
    height: 42px !important;
    padding: 0 0.85rem !important;
    border-radius: 6px !important;
    background: #fffaf0 !important;
    color: #5f584f !important;
    border: 1px solid rgba(110, 90, 66, 0.22) !important;
    box-shadow: 0 10px 22px rgba(58, 45, 34, 0.08) !important;
    font-weight: 700 !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease !important;
  }

  body:has(.instructor-editorial-page) .pg-pagination li button:hover {
    background: #f3eadb !important;
    color: #2f4f40 !important;
    border-color: rgba(47, 79, 64, 0.45) !important;
    transform: translateY(-2px) !important;
    box-shadow: 0 12px 24px rgba(58, 45, 34, 0.1) !important;
  }

  body:has(.instructor-editorial-page) .pg-pagination li button[style*="rgb(63, 81, 181)"],
  body:has(.instructor-editorial-page) .pg-pagination li button[style*="#3f51b5"] {
    background: #2f4f40 !important;
    color: #fffaf0 !important;
    border-color: #2f4f40 !important;
    box-shadow: 0 14px 28px rgba(47, 79, 64, 0.18) !important;
  }

  .instructor-action-title {
    color: #2d241b !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    font-weight: 500 !important;
    font-size: 1.65rem !important;
  }

  .instructor-action-card button {
    background: #2f4f40 !important;
    color: #fffaf0 !important;
    border: 1px solid #2f4f40 !important;
    border-radius: 6px !important;
    box-shadow: 0 12px 24px rgba(47, 79, 64, 0.18) !important;
    min-height: 56px !important;
    font-size: 0.98rem !important;
  }

  .instructor-action-card button:nth-child(2) {
    background: #8d4e2f !important;
    border-color: #8d4e2f !important;
  }

  .instructor-action-card button:nth-child(3),
  .instructor-action-card button:nth-child(4) {
    background: #fffaf0 !important;
    color: #2f4f40 !important;
    border: 1px solid rgba(47, 79, 64, 0.45) !important;
    box-shadow: none !important;
  }

  .instructor-editorial-page .MuiBox-root {
    background: rgba(255, 251, 243, 0.98) !important;
    border: 1px solid rgba(110, 90, 66, 0.2) !important;
    border-radius: 8px !important;
    box-shadow: 0 24px 70px rgba(58, 45, 34, 0.18) !important;
  }

  .instructor-editorial-page .MuiTypography-root {
    color: #2d241b;
  }

  @media (max-width: 768px) {
    .instructor-action-card {
      padding: 1.25rem !important;
    }

    .instructor-action-card button {
      min-width: 100% !important;
    }
  }
`;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const buttonStyle = {
  backgroundColor: "#3f51b5", 
  color: "#fff",
  padding: "12px 24px", 
  borderRadius: "8px", 
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)", 
  textTransform: "none", 
  fontSize: "14px", 
  fontWeight: "500",
  margin: "8px", 
  transition: "all 0.3s ease",
  cursor: "pointer",
  border: "none",
  minWidth: "180px",
};

const blueButtonStyle = {
  ...buttonStyle,
  backgroundColor: "#2196F3",
};

function InstructorDetail() {
  const dispatch = useDispatch();
  const [pageCounter, setPageCounter] = useState(0);
  const [courses, setCourses] = useState([]);
  const [instructorUpdate] = useInstructorUpdateMutation();
  const [categories, setCategories] = useState([]);
  const userId = useSelector((state) => state.authStore.nameIdentifier);
  const userEmail = useSelector((state) => state.authStore.email);
  const user = useSelector((state) => state.authStore);
  const [bankStateInfo,setBankStateInfo] = useState('')
  const [getAllStudentCourses] = useGetAllInstructorCoursesMutation();
  const [
    getAllCategories,
    { data: categoriesData, isLoading: isCategoriesLoading },
  ] = useLazyGetAllCategoriesForSelectedQuery();
  const [createCourseAsync] = useCreateCourseAsyncMutation();
  const [removeCourseAsync] = useRemoveCourseAsyncMutation();
  const [checkBankInformation] = useChechBankInformationMutation();
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });
  const [courseModel, setCourseModel] = useState({
    courseName: "",
    coursePrice: 0,
    courseLanguage: "",
    courseDescription: "",
    imageUrl: "",
    categoryId: "",
    introductionVideo: "",
    courseImage: "",
    isFree:false,
  });
  const [instructorDetails] = useInstructorSubDetailMutation();
  const [introductionVideo, setIntroductionVideo] = useState(null);
  const [image, setImage] = useState(null);
  const [open, setOpen] = useState(false);
  const [openCourseModal, setOpenCourseModal] = useState(false);
  const [isActiveButton, setIsActiveButton] = useState(true);
  const [isUpdateProcess, setIsUpdateProcess] = useState(false);
  const handleOpen = () => setOpen(true);
  const [openBankInfoModal, setOpenBankInfoModal] = useState(false);
  const [disableDom,setDisableDom] = useState(false);
  const [addBankInfo] = useAddBankInfoMutation();
  const [bankInfo, setBankInfo] = useState({
    InstructorName: '',
    InstructorSurname: '',
    IdentityNumber: '',
    Address: '',
    Iban: '',
    BankName: '',
    PaymentAccountId: '',
    InstructorBankDetailId:''
  });
  const handleClose = () => {
    setCourseModel({
      courseName: "",
      coursePrice: 0,
      courseLanguage: "",
      courseDescription: "",
      imageUrl: "",
      categoryId: "",
      introductionVideo: "",
      courseImage: "",
    }),
      setIsUpdateProcess(false),
      setOpen(false);
  };
  const redButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#ff1744",
  };
  const greenButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#00FF00",
  };

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = "#303f9f";
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = "#3f51b5";
  };
  const handleOpenCourseModal = () => setOpenCourseModal(true);
  const handleCloseCourseModal = () => setOpenCourseModal(false);
  const [getCourse] = useGetCourseByIdMutation();
  const [handleUpdateCourse] = useUpdateCourseMutation();
  const [courseId, setCourseId] = useState();
  const [filter, setFilter] = useState({
    isSearch: true,
    pageIndex: 1,
    pageSize: 6,
    sortColumn: "CourseName",
    sortOrder: "desc",
    filters: {
      groupOp: "AND",
      rules: [
        {
          field: "UserId",
          op: 1,
          data: "",
        },
      ],
    },
  });
  const [openBulkVideoModal, setOpenBulkVideoModal] = useState(false);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadingVideos, setUploadingVideos] = useState([]);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const [bulkVideoAsync] = useBulkVideoAsyncMutation();
  const [selectedSection, setSelectedSection] = useState('');
  const [sections, setSections] = useState([]);
  
  // Add a function to fetch course sections if needed
  const fetchCourseSections = async (courseId) => {
    // This is a placeholder. You'll need to implement an actual API call to fetch sections
    // For now, we'll use dummy data
    setSections([
      { sectionId: '3fa85f64-5717-4562-b3fc-2c963f66afa6', sectionName: 'Introduction' },
      { sectionId: '4fa85f64-5717-4562-b3fc-2c963f66afa7', sectionName: 'Advanced Topics' },
    ]);
  };

  useEffect(() => {
    async function fetchData() {
      // You can await here
      await getAllStudentCourses(filter).then((response) => {
        setCourses(response.data.result != [] ? response.data.result.data : []);
        // setCurrentPage(response.data.result.data)
        setPageCounter(response.data.result.paginationCounter);
      });
      // ...
    }
    fetchData();
  }, [filter, open]);


  const openManuelBankInfoModal = async  () => {

    console.log("userId openManuelBankInfoModal",user)

    await instructorDetails(user.InstructorSubId).then((response) => {
      console.log("instructorDetails response",response)
      if (response.data.isSuccess) {
        setBankInfo((prevState) =>({
          ...prevState,
          InstructorName:response.data.result.instructorName,
          InstructorSurname:response.data.result.instructorSurname,
          IdentityNumber:response.data.result.identityNumber,
          Address:response.data.result.address,
          Iban:response.data.result.instructorBankDetail.iban,
          BankName:response.data.result.instructorBankDetail.bankName,
        }))
        setBankStateInfo("update")
        setOpenBankInfoModal(true)
        
      }
      else {
        toast.warning("Üye iş yeri ile ilgili bir problem var. Lütfen destek ile iletişime geçin.")
      }
    })



  }


  useEffect(() => {
    if (categoriesData) {
      setCategories(categoriesData.result);
    }
  }, [categoriesData]);

  useEffect(() => {
    // alert("Please be carefull! while You are added  introduction video for create new course,video duration must is not duration 10 seconds than high")
    if (userId) {
      checkBankInformation(userId).then((response) => {
        if(!response.data.isSuccess){
          toast.warning(response.data.message)
          setDisableDom(true);
          setOpenBankInfoModal(true);
        }
      })
    }
   
    
    getAllCategories();
  }, [userId]);



  const checkUserBankDetail = () => {
    if (userId) {
      checkBankInformation(userId).then((response) => {
        if(!response.data.isSuccess){
          toast.warning(response.data.message)
          setDisableDom(true);

          setOpenBankInfoModal(true);
          setOpen(false)
          return;
        }
      })
    }
  }


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBankInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleModalClose = () => {
    setOpenBankInfoModal(false);
  };
  // if (isCoursesLoading || isCategoriesLoading) {
  //   return <IsLoading />;
  // }
  const handleClickChangePageNumber = (clickedPageNumber) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageIndex: clickedPageNumber,
    }));
  };

  const createCourse = async () => {
    if (image == null) {
      alert("Please Check Your Course Image");
      return;
    }
    var result = image.type.split("/");

    if (result[0] != "image") {
      alert("You must choosen only image");
      return;
    }

    // if (imageDimensions.width > 2270 && imageDimensions.height > 860) {
    //   alert(
    //     "Please check your image dimension.Image dimension so high. Max dimension is 1170x867"
    //   );
    //   return;
    // }

    setIsActiveButton(false);
    const formData = new FormData();
    formData.append("CourseName", courseModel.courseName);
    formData.append("CoursePrice", courseModel.coursePrice);
    formData.append("CourseLanguage", courseModel.courseLanguage);
    formData.append("CourseDescription", courseModel.courseDescription);
    formData.append("IntroductionVideo", introductionVideo);
    formData.append("Image", image);
    formData.append("ImageUrl", courseModel.imageUrl);
    formData.append("CategoryId", courseModel.categoryId);
    formData.append("IsFree",courseModel.isFree)

    await createCourseAsync(formData).then((response) => {
      if (response.data.isSuccess) {
        setIsActiveButton(true);

        handleClose();
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
        toast.success(response.data.messages[0]);
      } else {
        setIsActiveButton(true);

        toast.error(response.data.errorMessages[0]);
      }
    });
  };

  const handleRemoveCourse = async (courseId) => {
    const answer = window.confirm(
      "Are you sure you want to delete this course?"
    );
    if (answer) {
      await removeCourseAsync(courseId).then((response) => {

        if (response.data.isSuccess) {
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          dispatch(instructorApi.util.invalidateTags(["instructor"]));
          toast.success("Course removed successfully");
          setOpenCourseModal(false);
        }
      });
    }
  };

  const handleGetCourse = async (courseId) => {
    // response.data.result.item1
    setCourseId(courseId);
    await getCourse(courseId).then((response) => {
      if (response.data.isSuccess) {
        setIsUpdateProcess(true);
        setCourseModel({
          courseName: response.data.result.item1.courseName,
          coursePrice: response.data.result.item1.coursePrice,
          courseLanguage: response.data.result.item1.courseLanguage,
          courseDescription: response.data.result.item1.courseDescription,
          introductionVideo: response.data.result.item1.introductionVideoUrl,
          courseImage: response.data.result.item1.courseImage,
          categoryId: response.data.result.item1.categoryId,
        });

        handleOpen();
      } else {
      }
    });
  };

  const updateCourse = async () => {
    // formData.append("IntroductionVideo", introductionVideo);
    // formData.append("Image", image);

    const formData = new FormData();
    formData.append("CourseName", courseModel.courseName);
    formData.append("CoursePrice", courseModel.coursePrice);
    formData.append("CourseLanguage", courseModel.courseLanguage);
    formData.append("CourseDescription", courseModel.courseDescription);
    formData.append("IntroductionVideo", introductionVideo);
    formData.append("Image", image);
    formData.append("ImageUrl", courseModel.imageUrl);
    formData.append("CategoryId", courseModel.categoryId);
    formData.append("IsFree", courseModel.isFree == undefined ? false : courseModel.isFree);

    const courseUpdateModel = {
      courseId: courseId,
      formData: formData,
    };
    setIsActiveButton(false);

    await handleUpdateCourse(courseUpdateModel).then((response) => {
      console.log("trigger update course response", response);
      if (response.data.isSuccess) {
        setImage(null);
        setIsActiveButton(true);
        setIntroductionVideo(null);
        toast.success(response.data.messages[0]);
        dispatch(instructorApi.util.invalidateTags(["instructor"]));
        handleClose();
      } else {
        setIsActiveButton(true);

        toast.error(response.data.errorMessages[0]);
      }
    });
  };



  const handleSubmit = () => {
      if (bankStateInfo != "update") {
        var formData = new FormData();
        formData.append("InstructorName",bankInfo.InstructorName);
        formData.append("InstructorSurname",bankInfo.InstructorSurname);
        formData.append("IdentityNumber",bankInfo.IdentityNumber);
        formData.append("Address",bankInfo.Address);
        formData.append("Iban",bankInfo.Iban);
        formData.append("BankName",bankInfo.BankName);
        formData.append("InstructorBankDetailId",bankInfo.InstructorBankDetailId);


        addBankInfo(
          formData,
        /* Generate or set this appropriately */
        )
          .then((response) => {
            if (response.data.isSuccess) {
              toast.success('Bank information saved successfully!');
              setDisableDom(false);

              handleModalClose();
            } else {
              toast.error(response.data.message);
            }
          });
      }
      else {


        var formData = new FormData();
        formData.append("InstructorSubId",user.InstructorSubId)
        formData.append("InstructorName",bankInfo.InstructorName);
        formData.append("InstructorSurname",bankInfo.InstructorSurname);
        formData.append("IdentityNumber",bankInfo.IdentityNumber);
        formData.append("Address",bankInfo.Address);
        formData.append("Iban",bankInfo.Iban);
        formData.append("BankName",bankInfo.BankName);
        formData.append("InstructorBankDetailId",bankInfo.InstructorBankDetailId);
        formData.append("Email",userEmail);


        instructorUpdate(
          formData,
        )
          .then((response) => {
            if (response.data.isSuccess) {
              toast.success('Bank information saved successfully!');
              setDisableDom(false);

              handleModalClose();
            } else {
              toast.warning("Alt üye işyeri ile ilgili bir problem var. Lütfen destek ile iletişime geçin.");
            }
          });
      }
   
  };




  const handleImageChange = (e) => {
    const file = e.target.files[0];

    var fileResult = file.type.split("/");

    if (fileResult[0] != "image") {
      alert("You must choosen only image");
    }

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          setImageDimensions({ width: img.width, height: img.height });
          if (img.width > 4170 && img.height > 2867) {
            toast.error("Image dimension so high. Max dimension is 1170x867");
          } else {
            setImage(file);
          }
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }
  };
  const { t, i18n } = useTranslation();

  const handleOpenBulkVideoModal = () => {
    checkUserBankDetail();
    setOpenBulkVideoModal(true);
  };
  
  const handleCloseBulkVideoModal = () => {
    if (isUploading) {
      const confirmClose = window.confirm("Video yükleme devam ediyor. Çıkmak istediğinizden emin misiniz?");
      if (!confirmClose) return;
    }
    setOpenBulkVideoModal(false);
    setSelectedVideos([]);
    setUploadProgress(0);
    setUploadingVideos([]);
    setUploadedSize(0);
    setTotalSize(0);
    setIsUploading(false);
  };

  const handleVideoSelection = (e) => {
    const files = Array.from(e.target.files);
    
    // Validate files are videos
    const validVideos = files.filter(file => {
      const fileType = file.type.split('/')[0];
      if (fileType !== 'video') {
        toast.warning(`${file.name} is not a video file`);
        return false;
      }
      return true;
    });
    
    setSelectedVideos(prevVideos => [...prevVideos, ...validVideos]);
  };

  const removeSelectedVideo = (index) => {
    setSelectedVideos(prevVideos => prevVideos.filter((_, i) => i !== index));
  };

  const handleBulkUpload = async () => {
    if (selectedVideos.length === 0) {
      toast.warning("Please select at least one video to upload");
      return;
    }

    setIsUploading(true);
    setUploadProgress(0);
    
    // Initialize upload status for each video
    const videoStatuses = selectedVideos.map((video, index) => ({
      id: index,
      name: video.title || video.name.split('.')[0],
      progress: 0,
      status: 'waiting' // waiting, uploading, completed, error
    }));
    setUploadingVideos(videoStatuses);

    try {
      // Upload videos sequentially to track individual progress
      let totalProgress = 0;
      
      for (let i = 0; i < selectedVideos.length; i++) {
        const video = selectedVideos[i];
        
        // Update status to uploading
        setUploadingVideos(prev => 
          prev.map((v, idx) => idx === i ? {...v, status: 'uploading'} : v)
        );

        const formData = new FormData();
        formData.append(`bulkModel[0].File`, video);
        formData.append(`bulkModel[0].Title`, video.title || video.name.split('.')[0]);
        
        if (selectedSection) {
          formData.append(`bulkModel[0].SectionId`, selectedSection);
        }
        
        formData.append(`bulkModel[0].RowNumberForSection`, i + 1);

        try {
          const response = await bulkVideoAsync(formData);
          
          if (response.data.isSuccess) {
            // Mark as completed
            setUploadingVideos(prev => 
              prev.map((v, idx) => idx === i ? {...v, progress: 100, status: 'completed'} : v)
            );
            totalProgress = ((i + 1) / selectedVideos.length) * 100;
            setUploadProgress(totalProgress);
          } else {
            // Mark as error
            setUploadingVideos(prev => 
              prev.map((v, idx) => idx === i ? {...v, status: 'error'} : v)
            );
            toast.error(`${video.name}: ${response.data.errorMessages[0] || "Upload failed"}`);
          }
        } catch (error) {
          // Mark as error
          setUploadingVideos(prev => 
            prev.map((v, idx) => idx === i ? {...v, status: 'error'} : v)
          );
          toast.error(`${video.name}: Upload failed`);
        }
      }
      
      // Check if all succeeded
      const allCompleted = videoStatuses.every(v => v.status === 'completed');
      if (allCompleted) {
        toast.success("All videos uploaded successfully!");
        setTimeout(() => {
          handleCloseBulkVideoModal();
        }, 1500);
      } else {
        toast.warning("Some videos failed to upload. Please try again.");
      }
      
    } catch (error) {
      toast.error("An error occurred during upload");
      console.error("Upload error:", error);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Fragment>
      <style>{shimmerStyles}</style>
      <Navbar />
      <div className="instructor-editorial-page" id="disableId" style={{
          pointerEvents: disableDom? "none":"auto",
          opacity: disableDom? 0.5: ""}} >
      <PageTitle pageTitle={"Instructor"} pagesub={"Instructor"} />
      
      {/* Action Buttons Section */}
      <div style={{ 
        maxWidth: "1200px", 
        margin: "30px auto", 
        padding: "0 20px"
      }}>
        <div className="instructor-action-card" style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
          marginBottom: "30px"
        }}>
          <Typography className="instructor-action-title" variant="h6" style={{ 
            marginBottom: "20px", 
            color: "#333",
            fontWeight: "600"
          }}>
            Hızlı İşlemler
          </Typography>
          
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "15px",
            justifyItems: "center"
          }}>
            <Button
              onClick={() => { checkUserBankDetail(); handleOpen(); }}
              style={{...buttonStyle, width: "100%"}}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <span style={{ marginRight: "8px" }}>➕</span>
              Yeni Kurs Oluştur
            </Button>

            <Button
              onClick={handleOpenCourseModal}
              style={{...redButtonStyle, width: "100%"}}
            >
              <span style={{ marginRight: "8px" }}>🗑️</span>
              Kurs Sil
            </Button>

            <Button
              onClick={openManuelBankInfoModal}
              style={{...greenButtonStyle, width: "100%"}}
            >
              <span style={{ marginRight: "8px" }}>🏦</span>
              Banka Bilgileri
            </Button>

            <Button
              onClick={handleOpenBulkVideoModal}
              style={{...blueButtonStyle, width: "100%"}}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#0b7dda"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "#2196F3"}
            >
              <span style={{ marginRight: "8px" }}>📹</span>
              Toplu Video Yükle
            </Button>
          </div>
        </div>
      </div>
    
    {/* Existing modals */}
    <Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={{
    ...style,
    p: 4,
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    maxWidth: '700px',
    width: '90%',
    margin: '0 auto',
    position: 'relative',
    maxHeight: '90vh',
    overflowY: 'auto'
  }}>
    <Typography id="modal-modal-title" variant="h5" component="h2" sx={{ 
      mb: 4, 
      fontWeight: '700', 
      textAlign: 'center',
      color: '#333',
      borderBottom: '3px solid #3f51b5',
      paddingBottom: '12px'
    }}>
      {isUpdateProcess ? t("Update Course") : t("Create Course")}
    </Typography>

    <div className="col" style={{ gap: '24px', display: 'flex', flexDirection: 'column' }}>
      {/* Basic Information Section */}
      <div style={{
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        border: '1px solid #e0e0e0'
      }}>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: '600', color: '#3f51b5' }}>
          📝 {t("Basic Information")}
        </Typography>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', fontSize: '14px', color: '#555' }}>
              {t("Course Name")}
            </label>
            <Input
              type="text"
              placeholder={t("Enter course name")}
              value={courseModel.courseName || ""}
              onChange={(e) =>
                setCourseModel({
                  ...courseModel,
                  courseName: e.target.value,
                })
              }
              style={{ 
                padding: '12px', 
                borderRadius: '8px', 
                border: '1px solid #ddd',
                width: '100%',
                fontSize: '14px'
              }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px',
              backgroundColor: courseModel.isFree ? '#e8f5e9' : '#fff',
              borderRadius: '8px',
              border: '1px solid ' + (courseModel.isFree ? '#4CAF50' : '#ddd'),
              transition: 'all 0.3s ease'
            }}>
              <input
                type="checkbox"
                checked={courseModel.isFree}
                onChange={(e) => {
                  const value = e.target.checked;
                  if (value) {
                    setCourseModel({ ...courseModel, coursePrice: 0, isFree: true });
                  } else {
                    setCourseModel({ ...courseModel, isFree: false });
                  }
                }}
                style={{ 
                  width: '20px', 
                  height: '20px', 
                  cursor: 'pointer',
                  accentColor: '#4CAF50'
                }}
              />
              <label style={{
                fontWeight: '500',
                fontSize: '14px',
                color: '#333',
                margin: 0,
                cursor: 'pointer'
              }}>
                💰 {t("Is this course free?")}
              </label>
            </div>
            
            <div>
              <label style={{ 
                display: 'block', 
                marginBottom: '8px', 
                fontWeight: '500', 
                fontSize: '14px', 
                color: courseModel.isFree ? '#999' : '#555'
              }}>
                {t("Course Price")} {!courseModel.isFree && <span style={{ fontSize: '12px', color: '#666' }}>({t("Turkish Lira")})</span>}
              </label>
              <Input
                type="number"
                placeholder={t("Enter price")}
                value={courseModel.isFree ? 0 : courseModel.coursePrice || 0}
                onChange={(e) =>
                  setCourseModel({
                    ...courseModel,
                    coursePrice: e.target.value,
                  })
                }
                disabled={courseModel.isFree}
                style={{ 
                  padding: '12px', 
                  borderRadius: '8px', 
                  border: '1px solid #ddd',
                  width: '100%',
                  fontSize: '14px',
                  backgroundColor: courseModel.isFree ? '#f5f5f5' : '#fff',
                  cursor: courseModel.isFree ? 'not-allowed' : 'text'
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Language and Description Section */}
      <div style={{
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        border: '1px solid #e0e0e0'
      }}>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: '600', color: '#3f51b5' }}>
          🌍 {t("Language & Description")}
        </Typography>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', fontSize: '14px', color: '#555' }}>
              {t("Course Language")}
            </label>
            <select
              onChange={(e) =>
                setCourseModel({
                  ...courseModel,
                  courseLanguage: e.target.value,
                })
              }
              value={courseModel.courseLanguage || ""}
              title="languages"
              style={{ 
                padding: '12px', 
                borderRadius: '8px', 
                border: '1px solid #ddd',
                width: '100%',
                fontSize: '14px',
                backgroundColor: '#fff',
                cursor: 'pointer'
              }}
            >
              <option value="" disabled>
                {t("Select Language")}
              </option>
              {Languages.map((language, index) => (
                <option key={index} value={language}>
                  {language}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', fontSize: '14px', color: '#555' }}>
              {t("Course Description")}
            </label>
            <textarea
              placeholder={t("Enter course description")}
              value={courseModel.courseDescription || ""}
              onChange={(e) =>
                setCourseModel({
                  ...courseModel,
                  courseDescription: e.target.value,
                })
              }
              rows={4}
              style={{ 
                padding: '12px', 
                borderRadius: '8px', 
                border: '1px solid #ddd',
                width: '100%',
                fontSize: '14px',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
            />
          </div>
        </div>
      </div>

      {/* Media Upload Section */}
      <div style={{
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        border: '1px solid #e0e0e0'
      }}>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: '600', color: '#3f51b5' }}>
          🎬 {t("Course Media")}
        </Typography>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Introduction Video */}
          <div>
            <label style={{ display: 'block', marginBottom: '12px', fontWeight: '500', fontSize: '14px', color: '#555' }}>
              📹 {t("Introduction Video")}
            </label>
            {courseModel.introductionVideo && (
              <div style={{ marginBottom: '12px' }}>
                <video 
                  src={courseModel.introductionVideo} 
                  controls 
                  style={{ 
                    width: '100%', 
                    borderRadius: '8px',
                    maxHeight: '250px',
                    border: '2px solid #e0e0e0'
                  }}
                />
              </div>
            )}
            <div style={{
              border: '2px dashed #3f51b5',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center',
              backgroundColor: '#f5f7ff',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}>
              <Input
                type="file"
                accept="video/*"
                onChange={(e) => setIntroductionVideo(e.target.files[0])}
                style={{ cursor: 'pointer' }}
              />
              {!courseModel.introductionVideo && (
                <Typography variant="caption" sx={{ display: 'block', mt: 1, color: '#666' }}>
                  {t("Click to upload introduction video")}
                </Typography>
              )}
            </div>
          </div>

          {/* Course Image */}
          <div>
            <label style={{ display: 'block', marginBottom: '12px', fontWeight: '500', fontSize: '14px', color: '#555' }}>
              🖼️ {t("Course Image")}
            </label>
            {courseModel.courseImage && (
              <div style={{ marginBottom: '12px' }}>
                <img 
                  src={courseModel.courseImage} 
                  alt="Course" 
                  style={{ 
                    width: '100%', 
                    borderRadius: '8px',
                    maxHeight: '250px',
                    objectFit: 'cover',
                    border: '2px solid #e0e0e0'
                  }} 
                />
              </div>
            )}
            <div style={{
              border: '2px dashed #4CAF50',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center',
              backgroundColor: '#f1f8f4',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}>
              <Input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                style={{ cursor: 'pointer' }}
              />
              {!courseModel.courseImage && (
                <Typography variant="caption" sx={{ display: 'block', mt: 1, color: '#666' }}>
                  {t("Click to upload course image (Max: 1170x867)")}
                </Typography>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Additional Settings Section */}
      <div style={{
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        border: '1px solid #e0e0e0'
      }}>
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: '600', color: '#3f51b5' }}>
          ⚙️ {t("Additional Settings")}
        </Typography>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', fontSize: '14px', color: '#555' }}>
              🔗 {t("Image URL")} <span style={{ fontSize: '12px', color: '#999' }}>({t("Optional")})</span>
            </label>
            <Input
              type="text"
              placeholder={t("Enter image URL")}
              value={courseModel.imageUrl || ""}
              onChange={(e) =>
                setCourseModel({
                  ...courseModel,
                  imageUrl: e.target.value,
                })
              }
              style={{ 
                padding: '12px', 
                borderRadius: '8px', 
                border: '1px solid #ddd',
                width: '100%',
                fontSize: '14px'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', fontSize: '14px', color: '#555' }}>
              📚 {t("Category")}
            </label>
            <select
              onChange={(e) =>
                setCourseModel({
                  ...courseModel,
                  categoryId: e.target.value,
                })
              }
              value={courseModel.categoryId || ""}
              title="categories"
              style={{ 
                padding: '12px', 
                borderRadius: '8px', 
                border: '1px solid #ddd',
                width: '100%',
                fontSize: '14px',
                backgroundColor: '#fff',
                cursor: 'pointer'
              }}
            >
              <option value="" disabled>
                {t("Choose Category")}
              </option>
              {categories.map((category) => (
                <option key={category.categoryId} value={category.categoryId}>
                  {category.categoryName}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>

    <div style={{ 
      marginTop: '30px', 
      paddingTop: '20px', 
      borderTop: '2px solid #e0e0e0',
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-end'
    }}>
      <Button 
        onClick={handleClose}
        variant="outlined"
        disabled={!isActiveButton}
        sx={{ 
          minWidth: '120px',
          padding: '10px 24px',
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: '500'
        }}
      >
        {t("Cancel")}
      </Button>
      
      {!isUpdateProcess ? (
        <Button 
          disabled={!isActiveButton} 
          onClick={createCourse} 
          variant="contained" 
          color="primary" 
          sx={{ 
            minWidth: '140px',
            padding: '10px 24px',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '600',
            boxShadow: '0 4px 12px rgba(63, 81, 181, 0.3)'
          }}
        >
          {isActiveButton ? `✅ ${t("Save Course")}` : <Spinner animation="border" size="sm" />}
        </Button>
      ) : (
        <Button 
          disabled={!isActiveButton} 
          onClick={updateCourse} 
          variant="contained" 
          color="primary" 
          sx={{ 
            minWidth: '140px',
            padding: '10px 24px',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: '600',
            boxShadow: '0 4px 12px rgba(63, 81, 181, 0.3)'
          }}
        >
          {isActiveButton ? `🔄 ${t("Update Course")}` : <Spinner animation="border" size="sm" />}
        </Button>
      )}
    </div>
  </Box>
</Modal>


  <BankInfoModal
        open={openBankInfoModal}
        onClose={handleModalClose}
        bankInfo={bankInfo}
        onInputChange={handleInputChange}
        onSubmit={handleSubmit}
        type={bankStateInfo}
      />
        <Modal
          open={openCourseModal}
          onClose={handleCloseCourseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            ...style,
            maxWidth: '800px',
            width: '90%',
            maxHeight: '85vh',
            overflowY: 'auto',
            borderRadius: 4,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            border: 'none'
          }}>
            <Typography 
              id="modal-modal-title" 
              variant="h5" 
              component="h2"
              sx={{
                mb: 3,
                pb: 2,
                fontWeight: '700',
                textAlign: 'center',
                color: '#333',
                borderBottom: '3px solid #ff1744'
              }}
            >
              🗑️ {t("Manage Your Courses")}
            </Typography>
            
            {courses.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '60px 20px',
                color: '#999'
              }}>
                <Typography variant="h6" sx={{ mb: 2, color: '#666' }}>
                  📚 {t("No courses found")}
                </Typography>
                <Typography variant="body2">
                  {t("Create your first course to get started")}
                </Typography>
              </div>
            ) : (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                gap: '20px',
                padding: '10px'
              }}>
                {courses.map((course) => (
                  <div 
                    key={course.courseId}
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                      transition: 'all 0.3s ease',
                      border: '1px solid #f0f0f0',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                      e.currentTarget.style.transform = 'translateY(-4px)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    {/* Course Image */}
                    {course.courseImage && (
                      <div style={{
                        width: '100%',
                        height: '160px',
                        overflow: 'hidden',
                        backgroundColor: '#f5f5f5'
                      }}>
                        <img 
                          src={course.courseImage} 
                          alt={course.courseName}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      </div>
                    )}
                    
                    {/* Course Info */}
                    <div style={{ padding: '20px' }}>
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          mb: 1.5,
                          fontWeight: '600',
                          color: '#333',
                          fontSize: '16px',
                          lineHeight: '1.4',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          minHeight: '44px'
                        }}
                      >
                        {course.courseName}
                      </Typography>
                      
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        marginBottom: '16px'
                      }}>
                        {course.coursePrice !== undefined && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <span style={{ fontSize: '14px' }}>💰</span>
                            <Typography variant="body2" sx={{ color: '#666', fontSize: '13px' }}>
                              {course.isFree ? (
                                <span style={{ color: '#4CAF50', fontWeight: '600' }}>{t("Free")}</span>
                              ) : (
                                <span style={{ fontWeight: '600', color: '#333' }}>
                                  ₺{course.coursePrice}
                                </span>
                              )}
                            </Typography>
                          </div>
                        )}
                        
                        {course.courseLanguage && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <span style={{ fontSize: '14px' }}>🌍</span>
                            <Typography variant="body2" sx={{ color: '#666', fontSize: '13px' }}>
                              {course.courseLanguage}
                            </Typography>
                          </div>
                        )}
                      </div>
                      
                      {/* Delete Button */}
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => handleRemoveCourse(course.courseId)}
                        sx={{
                          backgroundColor: '#ff1744',
                          color: '#fff',
                          padding: '10px',
                          borderRadius: '8px',
                          textTransform: 'none',
                          fontWeight: '600',
                          fontSize: '14px',
                          boxShadow: '0 2px 8px rgba(255, 23, 68, 0.3)',
                          '&:hover': {
                            backgroundColor: '#d50000',
                            boxShadow: '0 4px 12px rgba(255, 23, 68, 0.4)'
                          }
                        }}
                      >
                        🗑️ {t("Delete Course")}
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            <div style={{
              marginTop: '24px',
              paddingTop: '20px',
              borderTop: '2px solid #f0f0f0',
              textAlign: 'center'
            }}>
              <Button
                onClick={handleCloseCourseModal}
                variant="outlined"
                sx={{
                  minWidth: '140px',
                  padding: '10px 24px',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: '600',
                  borderColor: '#999',
                  color: '#666',
                  '&:hover': {
                    borderColor: '#333',
                    backgroundColor: '#f5f5f5'
                  }
                }}
              >
                {t("Close")}
              </Button>
            </div>
          </Box>
        </Modal>
        
    {/* Bulk Video Upload Modal */}
    <Modal
      open={openBulkVideoModal}
      onClose={handleCloseBulkVideoModal}
      aria-labelledby="bulk-video-modal-title"
      aria-describedby="bulk-video-modal-description"
      disableEscapeKeyDown={isUploading}
    >
      <Box sx={{
        ...style,
        width: '650px',
        maxWidth: '90vw',
        maxHeight: '85vh',
        overflowY: 'auto',
        p: 4,
        bgcolor: 'background.paper',
        borderRadius: 3,
        boxShadow: 24,
      }}>
        <Typography id="bulk-video-modal-title" variant="h6" component="h2" sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
          {isUploading ? '📤 Uploading Videos...' : t("Bulk Video Upload")}
        </Typography>
        
        {!isUploading ? (
          <>
            {/* Section Selection */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>
                {t("Select Course Section (Optional)")}
              </Typography>
              <select
                value={selectedSection}
                onChange={(e) => setSelectedSection(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  fontSize: '14px'
                }}
              >
                <option value="">{t("No specific section")}</option>
                {sections.map((section) => (
                  <option key={section.sectionId} value={section.sectionId}>
                    {section.sectionName}
                  </option>
                ))}
              </select>
            </Box>

            {/* Video Selection */}
            <Box sx={{ mb: 3 }}>
              <input
                accept="video/*"
                style={{ display: 'none' }}
                id="bulk-video-upload-input"
                multiple
                type="file"
                onChange={handleVideoSelection}
              />
              <label htmlFor="bulk-video-upload-input" style={{ width: '100%', display: 'block' }}>
                <Button
                  variant="contained"
                  component="span"
                  fullWidth
                  sx={{
                    py: 1.5,
                    bgcolor: '#4CAF50',
                    '&:hover': { bgcolor: '#45a049' },
                    borderRadius: 2,
                    textTransform: 'none',
                    fontSize: '1rem',
                  }}
                >
                  📁 {t("Select Videos")}
                </Button>
              </label>
              <Typography variant="caption" display="block" sx={{ mt: 1, color: 'text.secondary', textAlign: 'center' }}>
                {t("Only video files are allowed")}
              </Typography>
            </Box>

            {/* Selected Videos List */}
            {selectedVideos.length > 0 && (
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 'bold' }}>
                  {t("Selected Videos")} ({selectedVideos.length}):
                </Typography>
                <Box sx={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 2, p: 2 }}>
                  {selectedVideos.map((video, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 1.5,
                        mb: 1,
                        bgcolor: '#f5f5f5',
                        borderRadius: 1.5,
                        '&:last-child': { mb: 0 }
                      }}
                    >
                      <Box sx={{ flex: 1, overflow: 'hidden' }}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {video.name}
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                          {(video.size / (1024 * 1024)).toFixed(2)} MB
                        </Typography>
                      </Box>
                      <Button
                        size="small"
                        onClick={() => removeSelectedVideo(index)}
                        sx={{ minWidth: 'auto', color: 'error.main', ml: 2 }}
                      >
                        ✕
                      </Button>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Button
                onClick={handleCloseBulkVideoModal}
                variant="outlined"
                fullWidth
                sx={{
                  py: 1.5,
                  borderColor: '#d32f2f',
                  color: '#d32f2f',
                  '&:hover': { borderColor: '#b71c1c', bgcolor: 'rgba(211, 47, 47, 0.04)' },
                  borderRadius: 2,
                  textTransform: 'none',
                }}
              >
                {t("Cancel")}
              </Button>
              <Button
                onClick={handleBulkUpload}
                variant="contained"
                fullWidth
                disabled={selectedVideos.length === 0}
                sx={{
                  py: 1.5,
                  bgcolor: '#FF6B35',
                  '&:hover': { bgcolor: '#FF5722' },
                  '&:disabled': { bgcolor: '#cccccc' },
                  borderRadius: 2,
                  textTransform: 'none',
                }}
              >
                {t("Start Upload")} ({selectedVideos.length} videos)
              </Button>
            </Box>
          </>
        ) : (
          /* Enhanced Progress indicator - Always visible when uploading */
          <Box>
            {/* Main Progress Bar */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: '700', color: '#333', fontSize: '16px', mb: 1 }}>
                {Math.round(uploadProgress)}% uploaded
              </Typography>
              
              <Typography variant="body2" sx={{ color: '#666', mb: 2, fontSize: '13px' }}>
                Uploaded {(uploadedSize / (1024 * 1024)).toFixed(3)} Megabytes of {(totalSize / (1024 * 1024)).toFixed(3)}
              </Typography>
              
              <Box sx={{
                position: 'relative',
                height: '40px',
                bgcolor: '#f0f0f0',
                borderRadius: 2,
                overflow: 'hidden',
                border: '1px solid #e0e0e0'
              }}>
                <Box sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: `${uploadProgress}%`,
                  bgcolor: '#FF6B35',
                  transition: 'width 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <Typography variant="body2" sx={{
                    color: '#fff',
                    fontWeight: '600',
                    position: 'absolute',
                    zIndex: 2
                  }}>
                    {Math.round(uploadProgress)}%
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Individual Video Status */}
            {uploadingVideos.length > 0 && (
              <Box>
                <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: '600', color: '#333' }}>
                  Upload Status:
                </Typography>
                <Box sx={{
                  maxHeight: '180px',
                  overflowY: 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1
                }}>
                  {uploadingVideos.map((video, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        p: 1.5,
                        bgcolor: video.status === 'completed' ? '#f0fdf4' :
                                 video.status === 'error' ? '#fef2f2' :
                                 video.status === 'uploading' ? '#eff6ff' : '#f9fafb',
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: video.status === 'completed' ? '#86efac' :
                                     video.status === 'error' ? '#fca5a5' :
                                     video.status === 'uploading' ? '#93c5fd' : '#e5e7eb'
                      }}
                    >
                      <Box sx={{ fontSize: '18px', flexShrink: 0 }}>
                        {video.status === 'waiting' && '⏳'}
                        {video.status === 'uploading' && '🔄'}
                        {video.status === 'completed' && '✅'}
                        {video.status === 'error' && '❌'}
                      </Box>

                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" sx={{
                          fontWeight: '500',
                          color: '#333',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}>
                          {video.name}
                        </Typography>
                        <Typography variant="caption" sx={{
                          color: video.status === 'completed' ? '#16a34a' :
                                 video.status === 'error' ? '#dc2626' :
                                 video.status === 'uploading' ? '#2563eb' : '#6b7280',
                          fontWeight: '500'
                        }}>
                          {video.status === 'waiting' && 'Waiting...'}
                          {video.status === 'uploading' && 'Uploading...'}
                          {video.status === 'completed' && 'Completed'}
                          {video.status === 'error' && 'Failed'}
                        </Typography>
                      </Box>

                      <Typography variant="caption" sx={{ color: '#666', flexShrink: 0 }}>
                        {(video.size / (1024 * 1024)).toFixed(2)} MB
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Modal>
    
  </div>
  <div style={{ 
    maxWidth: "1200px", 
    margin: "0 auto", 
    padding: "0 20px 40px"
  }}>
    <CourseSectionS3
      courses={courses}
      component={"instructor"}
      onData={handleGetCourse}
    />
    
    {pageCounter > 1 && (
      <div style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "40px",
        padding: "20px",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)"
      }}>
        <div className="pagination-wrapper">
          <ul className="pg-pagination" style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            listStyle: "none",
            padding: 0,
            margin: 0
          }}>
            {filter.pageIndex != 1 && (
              <li>
                <Button
                  color="secondary"
                  aria-label="Previous"
                  onClick={() => handleClickChangePageNumber(filter.pageIndex - 1)}
                  style={{
                    minWidth: "40px",
                    height: "40px",
                    borderRadius: "8px"
                  }}
                >
                  <i className="fi ti-angle-left"></i>
                </Button>
              </li>
            )}

            {[...Array(pageCounter)].map((_, index) => (
              <li key={index}>
                <Button
                  color="secondary"
                  onClick={() => handleClickChangePageNumber(index + 1)}
                  style={{
                    minWidth: "40px",
                    height: "40px",
                    borderRadius: "8px",
                    backgroundColor: filter.pageIndex === index + 1 ? "#3f51b5" : "transparent",
                    color: filter.pageIndex === index + 1 ? "#fff" : "#333",
                    fontWeight: filter.pageIndex === index + 1 ? "600" : "normal"
                  }}
                >
                  {index + 1}
                </Button>
              </li>
            ))}
            
            {filter.pageIndex != pageCounter && (
              <li>
                <Button
                  color="secondary"
                  aria-label="Next"
                  onClick={() => handleClickChangePageNumber(filter.pageIndex + 1)}
                  style={{
                    minWidth: "40px",
                    height: "40px",
                    borderRadius: "8px"
                  }}
                >
                  <i className="fi ti-angle-right"></i>
                </Button>
              </li>
            )}
          </ul> 
        </div>
      </div>
    )}
  </div>
  <Footer />
  <Scrollbar />
</Fragment>
);
}

export default InstructorAuth(InstructorDetail);
